<div class="stikytop"></div>
<div class="contactParallax ">
    <div class="container" style="text-align: center;">
        <div class="row" style="height: 100px;"></div>
        <h1 class="mt-5" style="color: #fff;">Contact</h1>
    </div>
</div>
<div class="container propotion contactBackground  pt-5 pb-5">
    <div class="row adminDetails">
        <div class="col-md-5 col-sm-12 ">
            <!-- <h5 class="adminDetails">Sanjay Bhoola</h5>
            <h5 class="adminDetails">Head of Property & Travel</h5>
            <h5 class="adminDetails">Email:<a href="mailto:Sanjay.b@ducatus.net">Sanjay.b@ducatus.net</a></h5>
            <h5 class="adminDetails">Office: +971 4 399 1190</h5>
            <h5 class="adminDetails">Mobile: +971 50 92 66 365</h5> -->
        </div>
        <div class="col-md-6 col-sm-12 contactForm">
            <div class="container" style="text-align: center;">
                <div class="row">
                    <h4 class="adminDetails">Indicate Your interest today</h4>
                </div>
            </div>
            <form [formGroup]="getContactform" (ngSubmit)="OnsubmitingContactForm()">
                <div class="form-group mb-2 d-flex">
                    <div class="col-3">
                        <label>Name*</label>
                    </div>
                    <div class="col-8">
                        <input required formControlName="name" type="text" class="form-control" name="name"
                            [ngClass]="{ 'is-invalid': contactSubmitted && ctc.name.errors }" autofocus>
                        <div *ngIf="contactSubmitted && ctc.name.errors">
                            <div *ngIf="ctc.name.errors?.required" class="text-danger">
                                Name is Required
                            </div>
                        </div>
                        <div *ngIf="ctc.name.errors?.pattern" class="text-danger">
                            Name is invalid
                        </div>
                    </div>
                </div>
                <div class="form-group   mb-2 d-flex">
                    <div class="col-3">
                        <label>Email*</label>
                    </div>
                    <div class="col-8">
                        <input required formControlName="email" class="form-control" name="email"
                            [ngClass]="{ 'is-invalid': contactSubmitted && ctc.email.errors }">
                        <div *ngIf="contactSubmitted && ctc.email.errors">
                            <div *ngIf="ctc.email.errors?.required" class="text-danger">
                                Email is Required
                            </div>
                            <div *ngIf="ctc.email.errors?.email || ctc.email.errors?.pattern" class="text-danger">
                                Email is invalid
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group mb-2 d-flex">
                    <div class="col-3">
                        <label>Mobile*</label>
                    </div>
                    <div class="col-8">
                        <input required formControlName="mobile" type="number" class="form-control" name="mobile"
                            [ngClass]="{ 'is-invalid': contactSubmitted && ctc.mobile.errors }">
                        <div *ngIf="contactSubmitted && ctc.mobile.errors">
                            <div *ngIf="ctc.mobile.errors?.required" class="text-danger">
                                Mobile Number is Required
                            </div>
                        </div>
                        <div *ngIf="ctc.mobile.errors?.pattern" class="text-danger">
                            Mobile Number is invalid
                        </div>
                    </div>
                </div>
                
                <div class="row p-3">
                    <div class="col" style="text-align: center;">
                        <h6 style=" border: 2px solid #891b1d;">Preferred Location</h6>
                    </div>
                </div>
                <div class="form-group  mb-2 d-flex">
                    <div class="col-3">
                        <label>City*</label>
                    </div>
                    <div class="col-8">
                        <input required formControlName="city" class="form-control" name="city"
                            [ngClass]="{ 'is-invalid': contactSubmitted && ctc.city.errors }">
                        <div *ngIf="contactSubmitted && ctc.city.errors">
                            <div *ngIf="ctc.city.errors?.required" class="text-danger">
                                City is Required
                            </div>
                        </div>
                        <div *ngIf="ctc.city.errors?.pattern" class="text-danger">
                            City is invalid
                        </div>
                    </div>
                </div>
                <div class="form-group  mb-2 d-flex">
                    <div class="col-3">
                        <label>State*</label>
                    </div>
                    <div class="col-8">
                        <input required formControlName="state" class="form-control" name="state"
                            [ngClass]="{ 'is-invalid': contactSubmitted && ctc.state.errors }">
                        <div *ngIf="contactSubmitted && ctc.state.errors">
                            <div *ngIf="ctc.state.errors.required" class="text-danger">
                                State is Required
                            </div>
                        </div>
                        <div *ngIf="ctc.state.errors?.pattern" class="text-danger">
                            State is invalid
                        </div>
                    </div>
                </div>
                <div class="form-group  mb-2 d-flex">
                    <div class="col-3">
                        <label>Country*</label>
                    </div>
                    <div class="col-8">
                        <input required formControlName="country" class="form-control" name="country"
                            [ngClass]="{ 'is-invalid': contactSubmitted && ctc.country.errors }">
                        <div *ngIf="contactSubmitted && ctc.country.errors">
                            <div *ngIf="ctc.country.errors?.required" class="text-danger">
                                Country is Required
                            </div>
                        </div>
                        <div *ngIf="ctc.country.errors?.pattern" class="text-danger">
                            Country is invalid
                        </div>
                    </div>
                </div>
                <div class="form-group  mb-3 d-flex">
                    <div class="col-3">
                        <label>Message*</label>
                    </div>
                    <div class="col-8">
                        <textarea required formControlName="message" class="form-control" name="message"
                            [ngClass]="{ 'is-invalid': contactSubmitted && ctc.message.errors }"></textarea>
                        <div *ngIf="contactSubmitted && ctc.message.errors">
                            <div *ngIf="ctc.message.errors?.required" class="text-danger">
                                Message is Required
                            </div>
                        </div>
                        <div *ngIf="ctc.message.errors?.pattern" class="text-danger">
                            Message is invalid
                        </div>
                    </div>
                </div>
                <div class="row  mb-2">
                    <div class="col-3">
                        <div class="form-group d-flex">
                            <label>Bed Room Type*</label>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="form-group ">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="inlineCheckbox1" name="getRoom"
                                    value="option1" (click)="getBedRoomCount(1)">
                                <label class="form-check-label" for="inlineCheckbox1">1 BHK</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="inlineCheckbox2" name="getRoom"
                                    value="option2" (click)="getBedRoomCount(2)">
                                <label class="form-check-label" for="inlineCheckbox2">2 BHK</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="inlineCheckbox3" name="getRoom"
                                    value="option3" (click)="getBedRoomCount(3)">
                                <label class="form-check-label" for="inlineCheckbox3">3 BHK</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="inlineCheckbox4" name="getRoom"
                                    value="option4" (click)="getBedRoomCount(4)">
                                <label class="form-check-label" for="inlineCheckbox4">4 BHK</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <div class="form-group ">
                            <label>Budget*</label>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="form-group ">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="inlineCheckbox5" name="getBudget"
                                    value="option1" (click)="getBudget(1)">
                                <label class="form-check-label" for="inlineCheckbox5">500-1M</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="inlineCheckbox6" name="getBudget"
                                    value="option2" (click)="getBudget(2)">
                                <label class="form-check-label" for="inlineCheckbox6">1M-1.5M</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="inlineCheckbox7" name="getBudget"
                                    value="option3" (click)="getBudget(3)">
                                <label class="form-check-label" for="inlineCheckbox7">1.5M-2M</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="inlineCheckbox8" name="getBudget"
                                    value="option4" (click)="getBudget(4)">
                                <label class="form-check-label" for="inlineCheckbox8">2M ></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectionErr" class="text-danger">
                    Please select Required Fields
                </div>
                <div class="container" style="text-align: center;">
                    <button type="submit" class="btn btn-default float-center pr-5 pl-5 mt-3 contactSubmitBtn">Let Us
                        Contact You</button>
                </div>
                <div class="container p-2" *ngIf="isMailSent" style="text-align: center;">
                    <h6 class="text-success">Mail Sent Succesfully</h6>
                </div>
            </form>
        </div>
    </div>
</div>